import { Box, withStyles } from '@material-ui/core';
import { deepBlue } from 'globals/colors';
import FsButton from 'ui-elements/buttons/FsButton';

export const ImageWrapper = withStyles(({ spacing }) => ({
  root: {
    position: 'relative',
    justifyContent: 'center',
    height: 222,
    backgroundColor: deepBlue.V4,
    borderRadius: 10,
    marginBottom: spacing(2),
    overflow: 'hidden',
    '& svg': {
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translate(-50%, 0)',
    },
  },
}))(Box);

export const StyledButton = withStyles(({ spacing }) => ({
  root: {
    width: `100%`,
    maxWidth: 184,
    padding: spacing(1.4),
  },
}))(FsButton);
